var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":`${_vm.$paths.assetsUrl}img/check.svg`,"loading":"lazy","alt":"usp 24","width":"auto","height":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }